import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { LOGO_URL, NAV_SECTIONS } from "../lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-white text-olive mt-0">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 flex flex-col gap-6">
          <Link to="/" className="inline-block self-start" data-testid="footer-logo">
            <img src={LOGO_URL} alt="Agrovalor Iberica" className="h-56 sm:h-64 w-auto object-contain" style={{ mixBlendMode: "darken" }} />
          </Link>
          <p className="font-serif italic text-3xl sm:text-4xl leading-tight max-w-md text-olive/90">
            {t.footer.tagline}
          </p>
          <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-olive-soft">
            info@agrovaloriberica.com · Agrovalor Ibérica
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-olive-soft mb-5">{t.footer.sections}</div>
          <ul className="flex flex-col gap-3 font-serif text-lg">
            {NAV_SECTIONS.map((s) => (
              <li key={s}>
                <a href={"/#" + s} className="link-underline" data-testid={`footer-link-${s}`}>{t.nav[s]}</a>
              </li>
            ))}
            <li><a href="/#contacto" className="link-underline" data-testid="footer-link-contacto">{t.nav.contacto}</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-olive-soft mb-5">{t.footer.legal}</div>
          <ul className="flex flex-col gap-3 font-serif text-lg">
            <li><Link to="/legal/privacidad" className="link-underline" data-testid="footer-link-privacy">{t.footer.privacy}</Link></li>
            <li><Link to="/legal/aviso-legal" className="link-underline" data-testid="footer-link-terms">{t.footer.terms}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto max-w-[1500px] px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 font-mono text-[11px] tracking-[0.2em] uppercase text-olive-soft">
          <span>© {year} Agrovalor Ibérica. {t.footer.rights}</span>
          <span className="text-olive-soft/70">Agrovalor Ibérica · Plataforma agrícola</span>
        </div>
      </div>
    </footer>
  );
}
